// Modern Button System 2024 - Minimalista Sofisticado ZoeFel IA™
// Paleta: Índigo ZoeFel + Cian Innovación + Oro Sutil

export const modernButtons = {
  // Primary CTA - Cian Innovación (Principal conversión)
  primary: "relative px-8 py-4 rounded-2xl bg-[#00C2FF] text-white font-bold text-lg shadow-lg shadow-[#00C2FF]/25 hover:shadow-xl hover:shadow-[#00C2FF]/40 hover:scale-[1.02] hover:bg-[#2A1E42] active:scale-[0.98] transition-all duration-300 backdrop-blur-sm border border-[#00C2FF]/20",
  
  // Secondary CTA - Índigo ZoeFel Glassmorphism (Acciones secundarias)
  secondary: "relative px-8 py-4 rounded-2xl bg-[#2A1E42]/90 backdrop-blur-md text-white font-semibold text-lg shadow-lg shadow-[#2A1E42]/20 hover:shadow-xl hover:shadow-[#2A1E42]/30 hover:bg-[#2A1E42] hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 border border-[#2A1E42]/30",
  
  // Ghost Button - Outline Premium (CTAs alternativos)
  ghost: "relative px-8 py-4 rounded-2xl bg-white/10 backdrop-blur-md text-white font-semibold text-lg border-2 border-white/30 hover:bg-white/20 hover:border-white/50 hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 shadow-lg",
  
  // Minimal Button - Text Only (Links importantes)
  minimal: "relative px-6 py-3 rounded-xl text-[#00C2FF] font-semibold text-base hover:bg-[#F4F6F8] hover:scale-[1.02] active:scale-[0.98] transition-all duration-200"
};

// Modern Badge System 2024 - Minimalista Sofisticado
export const modernBadges = {
  // Discount Badge - Glassmorphism Premium
  discount: "inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-red-500/20 to-[#00C2FF]/20 backdrop-blur-md border border-red-400/30 text-red-100 font-bold text-sm shadow-lg shadow-red-500/20",
  
  // Feature Badge - Índigo Subtle
  feature: "inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#2A1E42]/10 backdrop-blur-sm border border-[#2A1E42]/30 text-[#2A1E42] font-semibold text-sm",
  
  // Premium Badge - Oro Sutil Gradient
  premium: "inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-[#BC9C71]/20 to-[#BC9C71]/30 backdrop-blur-md border border-[#BC9C71]/40 text-[#BC9C71] font-bold text-sm shadow-lg",
  
  // New Badge - Cian Minimal
  new: "inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#00C2FF]/10 backdrop-blur-sm border border-[#00C2FF]/30 text-[#00C2FF] font-semibold text-xs",
  
  // Status Badge - Gray Neutral
  status: "inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-gray-500/10 backdrop-blur-sm border border-gray-400/20 text-gray-600 font-medium text-xs"
};

// Floating Discount Badge - Hero Section
export const floatingDiscountBadge = "absolute -top-3 -right-3 px-5 py-2.5 rounded-2xl bg-gradient-to-br from-red-500 to-[#00C2FF] text-white font-black text-sm shadow-2xl shadow-red-500/50 animate-pulse border-2 border-white/20 backdrop-blur-sm";

// Pill Badge - Inline Text
export const pillBadge = "inline-flex items-center px-3 py-1 rounded-full bg-[#00C2FF]/10 text-[#00C2FF] font-bold text-xs mx-1 border border-[#00C2FF]/20";
